// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3xBcN","head":"ProcedureTableInfo_head__1c75r"};